<div  id="content" class="content block fixed w-full h-full left-0 z-100 bg-white shadow-xl overflow-auto scrollbar-none appear">
  <fun-overvew-meeting-direct [meeting]="meeting" [project]="project" (goBackEvent)="goBack()"></fun-overvew-meeting-direct>
</div>